export const loadScript = (src) => {
	return new Promise((resolve) => {
		const script = document.createElement('script')
		script.src = src
		script.onload = () => {
			resolve(true)
		}
		script.onerror = () => {
			resolve(false)
		}
		document.body.appendChild(script)
	})
}

export const loadLink = (href) => {
	return new Promise((resolve) => {
		const link = document.createElement('link')
		link.href = href
		link.onload = () => {
			resolve(true)
		}
		link.onerror = () => {
			resolve(false)
		}
		document.head.appendChild(link)
	})
}

export const openInNewTab = (href) => {
    Object.assign(document.createElement('a'), {
      target: '_blank',
      href: href,
    }).click();
}
  

  
